import { render, staticRenderFns } from "./yxlMoreNew.vue?vue&type=template&id=ab2b7442&"
import script from "./yxlMoreNew.vue?vue&type=script&lang=js&"
export * from "./yxlMoreNew.vue?vue&type=script&lang=js&"
import style0 from "./yxlMoreNew.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports